import { useCallback, useEffect, useState } from "react";
import {
  ResourceContextProvider,
  SimpleForm,
  Title,
  useNotify,
} from "react-admin";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import BackButtonToolbar from "features/BackButtonToolbar";
import { dormitoryRequests } from "api/dormitoryApi";
import dataProvider from "server/dataProvider";
import { useNotifyError } from "utils/useNotifyError";
import { DormitoryServicePath, ROOM_TYPES, STATE_SUBSIDIES, SUBSIDIES } from "utils/constants";
import SaveForm from "../SaveForm";

const EditStateSubsidy = () => {
  const notify = useNotify();
  const notifyError = useNotifyError();
  const navigate = useNavigate();
  const { typeId, id } = useParams();
  const roomTypeName = useLocation().state?.roomTypeName;
  const [defaultValues, setDefaultValues] = useState(null);

  const fetchDefaultValues = useCallback(async () => {
    try {
      const { data } = await dataProvider.customRequest(
        dormitoryRequests.getStateSubsidy(typeId, id),
        null,
        "GET",
      );
      setDefaultValues(data);
    } catch (err) {
      console.error(err);
      notify("Грешка при зареждане на данни. Опитайте да презаредите страницата.", { type: "error" });
    }
  }, [typeId, id, notify]);

  useEffect(() => {
    if (typeId && id) {
      fetchDefaultValues();
    }
  }, [typeId, id, fetchDefaultValues]);

  const handleSubmit = async data => {
    try {
      await dataProvider.customRequest(
        dormitoryRequests.updateStateSubsidy(typeId, id),
        {
          amount: data.amount,
          receptionTypeId: data.receptionTypeId,
          studentType: data.studentType,
          validFrom: data.validFrom,
          validTo: data.validTo,
        },
        "PUT",
      );
      notify("Успешно редактиране на държавна субсидия", { type: "success" });
      navigate(`/${DormitoryServicePath}${STATE_SUBSIDIES}`);
    } catch (err) {
      notifyError(err);
    }
  };

  return (
    <>
      <Title
        title={
          roomTypeName
            ? `Редактиране на държавна субсидия: ${roomTypeName}`
            : "Редактиране на държавна субсидия"
        }
      />
      <BackButtonToolbar />
      <ResourceContextProvider value={`${DormitoryServicePath}${ROOM_TYPES}/${typeId}/${SUBSIDIES}/${id}/edit`}>
        {defaultValues && (
          <SimpleForm
            defaultValues={defaultValues}
            onSubmit={handleSubmit}
          >
            <SaveForm />
          </SimpleForm>
        )}
      </ResourceContextProvider>
    </>
  );
};

export default EditStateSubsidy;
